import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';

// ----------------------------------------------------------------------

export default function RHFTextField({ name, helperText, type, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          type={type}
          sx={{
            color: '#D92D7F',
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#D92D7F', // Default border color
              },
              '&:hover fieldset': {
                borderColor: '#D92D7F', // Border color on hover
              },
              '&.Mui-focused fieldset': {
                borderColor: '#D92D7F', // Border color when focused
              },
              '&.Mui-disabled fieldset': {
                borderColor: '#D92D7F', // Border color when disabled
              },
            },
          }}
          value={type === 'number' && field.value === 0 ? '' : field.value}
          onChange={(event) => {
            if (type === 'number') {
              field.onChange(Number(event.target.value));
            } else {
              field.onChange(event.target.value);
            }
          }}
          error={!!error}
          helperText={error ? error?.message : helperText}
          {...other}
        />
      )}
    />
  );
}

RHFTextField.propTypes = {
  helperText: PropTypes.object,
  name: PropTypes.string,
  type: PropTypes.string,
};
